import { Dispatch, SetStateAction } from "react";
import {
    ChangesDetail,
    HQSiteChangesDTO,
    HQSiteChangesDetailDTO,
    HQSiteDetailsDTO,
} from "../../../api-client-nswag/taxportal-client";
import { upgradeSites } from "../../../pages/UpgradeSites/UpgradeSites.types";
import dxDataGrid from "devextreme/ui/data_grid";

export enum UpgradeSitesVars {
    MIN_SELECTED = 1,
}

export interface changesDetailData {
    pending: boolean;
    changes: HQSiteChangesDetailDTO[];
}

export interface manageSitesSelected {
    pending: boolean;
    sites: HQSiteDetailsDTO[];
}

export interface changesSelected {
    pending: boolean;
    changes: detailsGridData[];
}

export interface SitesSelectedProps {
    selectedSitesData: HQSiteDetailsDTO[];
    selectedSites: number[];
    setSelectedSites: Dispatch<SetStateAction<number[]>>;
    templateSelected: string;
    templateSelectedLabel: string;
    toggleSitesGrids: (hideSelected: boolean) => void;
    setActiveScreen: Dispatch<SetStateAction<string>>;
    isBatchUpgrade: boolean;
}
export interface BatchSitesSelectedProps {
    selectedSitesData: HQSiteDetailsDTO[];
    selectedSites: number[];
    setSelectedSites: Dispatch<SetStateAction<number[]>>;
    templateSelected: string;
    appName: string;
    setActiveScreen: Dispatch<SetStateAction<string>>;
    toggleSitesGrids: (hideSelected: boolean) => void;
    batchGridData: any[] | undefined;
    setBatchGridData: Dispatch<SetStateAction<any[] | undefined>>;
    isBatchUpgrade: boolean;
    setPageNumber: Dispatch<SetStateAction<number>>;
    pageNumber: number;
}

export interface ChangesDetailsProps {
    parentKey: number;
    parentComponent: any;
    selectedSites: number[];
    selectedChanges: HQSiteChangesDTO[];
    templateSelected: string;
    sourceTemplateId?: string;
    targetTemplateId?: string;
    comparisonId?: string;
    changesWStatus: HQSiteChangesDTO[];
    isPending: boolean;
    modifySelectedChanges: (newData: HQSiteChangesDTO, isToDownload?: boolean) => void;
    removingSelectedChanges: (rowKey: number) => void;
    isBatchUpgrade: boolean;
    onChildDataLoaded?: () => void;
}

export interface BatchChangesDetailsProps {
    parentKey: number;
    parentComponent: any;
    selectedSites: number[];
    selectedChanges: HQSiteChangesDTO[];
    templateSelected: string;
    sourceTemplateId?: string;
    targetTemplateId?: string;
    comparisonId?: string;
    changesWStatus: HQSiteChangesDTO[];
    isPending: boolean;
    modifySelectedChanges: (newData: HQSiteChangesDTO, isToDownload?: boolean) => void;
    removingSelectedChanges: (rowKey: number) => void;
    batchGridData: any[] | undefined;
    isBatchUpgrade: boolean;
    onChildDataLoaded?: () => void;
}

export interface ChangesCardProps {
    selectedChangesDetails: SelectedChangeData;
    isReviewOnly: boolean;
    selectedDetails?: SelectedDetailsData[];
    setSelectedDetails?: Dispatch<SetStateAction<SelectedDetailsData[]>>;
    setDisabledChanges?: Dispatch<SetStateAction<string[]>>;
    upgradedDetails?: SelectedDetailsData[];
    prevDataDetails?: PrevDataDetails[];
    parentComponent?: dxDataGrid<any, any>;
    isBatchUpgrade: boolean;
}

export interface SitesGridProps {
    sitesData: upgradeSites;
    selectedSites: number[];
    setSelectedSites: Dispatch<SetStateAction<number[]>>;
    setSelectedSitesData: Dispatch<SetStateAction<HQSiteDetailsDTO[]>>;
    dropDown: string;
    setDropDown: Dispatch<SetStateAction<string>>;
    setSelectedTemplateLabel: Dispatch<SetStateAction<string>>;
    fetchData: () => void;
    toggleSitesGrids: (hideSelected: boolean) => void;
    setPageNumber: Dispatch<SetStateAction<number>>;
    searchTerm: string | null;
    setSearchTerm: Dispatch<SetStateAction<string | null>>;
    setActiveScreen: Dispatch<SetStateAction<string>>;
    toggleBatchUpgradeSitesGrids: (IsBatchVisible: boolean) => void;
    batchGridData: any[] | undefined;
    setBatchGridData: Dispatch<SetStateAction<any[] | undefined>>;
    setIsBatchUpgrade: Dispatch<SetStateAction<boolean>>;
    IsBatchUpgrade: (batchUpgrade: boolean) => void;
    pageNumber: number;
    highlightComments: boolean;
    setHighlightComments: Dispatch<SetStateAction<boolean>>;
    highlightCustomPermissions: boolean;
    setHighlightCustomPermissions: Dispatch<SetStateAction<boolean>>;
}

export interface ModalSitesChangesProps {
    handleClose: () => void;
    isDisplayModal: boolean;
    idUpgradeSiteTracks: number | undefined;
}

export interface ModalReviewChangesProps {
    selectedChangesDetails: SelectedChangeData;
    isDisplayModal: boolean;
    handleClose: () => void;
    isReviewOnly: boolean;
    selectedDetails?: SelectedDetailsData[];
    setSelectedDetails?: Dispatch<SetStateAction<SelectedDetailsData[]>>;
    setDisabledChanges?: Dispatch<SetStateAction<string[]>>;
    upgradedDetails?: SelectedDetailsData[];
    prevDataDetails?: PrevDataDetails[];
    parentComponent?: dxDataGrid<any, any>;
    isBatchUpgrade: boolean;
}

export interface SelectedChangeData extends HQSiteChangesDetailDTO {
    detailSelected?: ChangesDetail;
    detailModified?: ChangesDetail;
}

export interface SelectedDetailsData {
    comparisonId: string;
    changeId: string | undefined;
    details: string[];
}

export interface PrevDataDetails {
    comparisonId: string;
    changeId: string | undefined;
    details: detailsGridData[];
}

export interface selectChangesProps {
    selectedChangesDetails: SelectedChangeData;
    selectedDetails?: SelectedDetailsData[];
    setSelectedDetails: Dispatch<SetStateAction<SelectedDetailsData[]>>;
    setDisabledChanges: Dispatch<SetStateAction<string[]>>;
    upgradedDetails?: SelectedDetailsData[];
    prevDataDetails?: PrevDataDetails[];
    parentComponent?: dxDataGrid<any, any>;
    isBatchUpgrade: boolean;
}

export interface detailsGridData {
    name: string;
    status?: string;
}

export interface manageChanges {
    pending: boolean;
    changes: HQSiteChangesDTO;
}

export interface selectedOptionType {
    value: number | undefined;
    label: string | undefined;
}

export const constants = {
    ACTIVE: "ACTIVE",
    BUTTON_RETRY_BATCHUPGRADE: "Retry Batch Upgrade",
    BUTTON_REVIEW_CHANGES: "Initiate Upgrade",
    BUTTON_CONFIRM: "Proceed to Upgrade",
    BUTTON_CANCEL: "Cancel",
    BUTTON_BACK: "Back to Upgrade Sites",
    BUTTON_DOWNLOAD_EXCEL: "Download Excel",
    MODAL_TITLE: "Change Details",
    SITES_SELECTED_TITLE: "Review changes",
    DETAILS_TITLE: "Change Analysis",
    STATUS_COLUMN: "status",
    UPGRADED_BY_COLUMN: "upgradeBy",
    DATE_COLUMN: "upgradeDate",
    DISABLED_CHECK: "#ddd",
    ALERT_MESSAGE: "Changes highlighted in red will impact the code. Please proceed carefully.",
    STATUSES: {
        SUCCESS: "Success",
        ERROR: "Error",
        PARTIALLY_SUCCESS: "Partially Success",
        PENDING: "Pending...",
        EMPTY: "Empty response",
        SPECIAL_STATUS: "Failed to fetch",
    },
    COLUMNS: {
        HQ_SITE_ID: "SiteID",
        ORG_ID: "Organisation ID",
        MDM_MASTER_CLIENT_ID: "Master ClientID",
        MDM_CLIENT_ID: "ClientID",
        NAME: "Site Name",
        COMMENTS: "Site Comments",
        HAS_COMMENT: "Has Comment",
        TEMPLATE_NAME_OLD: "Original Site Template",
        TEMPLATE_NAME_NEW: "Latest Site Template Applied",
        UPGRADE_DATE: "Upgrade Date",
        LAST_ACCESSED_DATE: "Last Accessed Date",
        STATUS: "Upgrade Status",
        EXCLUDE_7216_CONSENT: "Exclude 7216 Consent",
        CUSTOM_PERMISSION_APPLIED: "Custom Permissions",
        UPGRADED_BY: "Upgraded By",
    },
    FILE_SITE_UPGRADE_NAME: "SiteUpgarde_Result",
    FILE_COMPARISON_NAME: "Comparison_Result",
    EXCEL_FILE_EXTENSION: "xlsx",
    ZIP_FILE_EXTENSION: "zip",
    ALERT_TEXT_CLASS: "alert-text",
    BUTTON_BATCH_UPGRADE: "Batch Upgrade",
    BUTTON_UPGRADE_WITHOUT_COMPARISON: "Initiate Upgrade Without Comparison",
    ADDITIONAL_OFFSET: 300,
    BUFFER: 100,
};
